import type { HugeNumber } from "@/shared/numbers";
import type { HoverIdleCumulativeStatsState } from "../types";

type TotalHovCoreSpentSource = Readonly<
  Pick<HoverIdleCumulativeStatsState, "totalHovCoreSpent">
>;

export function resolveTotalHovCoreSpent(
  cumulativeStats: TotalHovCoreSpentSource,
): HugeNumber {
  return cumulativeStats.totalHovCoreSpent;
}
